import type { NavigationSection } from "./navigation.data";
import Link from "next/link";
import MegaMenuFooter from "./MegaMenuFooter";


function Badge({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-[#FCEA981F] text-yellow text-[9px] leading-none px-1.5 py-1 rounded-sm font-mono uppercase tracking-widest shrink-0">
      {children}
    </div>
  );
}

export default function AboutMegaMenu({
  clickSubmenu,
  sections,
  footerLabel,
  footerCta,
}: {
  clickSubmenu: (link: string, external?: boolean) => void;
  sections: NavigationSection[];
  footerLabel?: string;
  footerCta?: { title?: string; link?: string };
}) {
  const items = sections?.flatMap((section) => section?.links ?? []) ?? [];
  const groups = sections?.flatMap((section) => section?.groups ?? []) ?? [];
  const groupItems = groups.flatMap((group) => group?.links ?? []);
  const allItems = [...items, ...groupItems];

  return (
    <MegaMenuFooter clickSubmenu={clickSubmenu} footerLabel={footerLabel} footerCta={footerCta}>
      <div className="flex xl:h-full xl:flex-row flex-col gap-2">
        {/* Items, single column — no category rail, no promo card */}
        <div className="grid grid-cols-1 gap-y-6 xl:w-[220px] shrink-0 xl:pt-1 content-start">
          {allItems.map((item) => (
            <Link
              key={item.id}
              href={item.link}
              target={item.external ? "_blank" : undefined}
              onClick={() => clickSubmenu(item.link, item.external)}
              className="group flex items-center gap-2"
            >
              <span className="text-white text-sm font-medium leading-tight transition-colors group-hover:text-white/70">
                {item.title}
              </span>
              {item.badge && <Badge>{item.badge}</Badge>}
            </Link>
          ))}
        </div>
      </div>
    </MegaMenuFooter>
  );
}
